import { useState, useEffect } from 'react';
import { fetchSavedJobs } from '../../../services/api';

const useSavedJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadSavedJobs = async () => {
      try {
        setLoading(true);
        const data = await fetchSavedJobs();
        const normalized = Array.isArray(data)
          ? data
              .map((item) => {
                if (!item) return null;
                if (item.job) return { ...item.job, isSaved: true };
                return { ...item, isSaved: true };
              })
              .filter(Boolean)
          : [];
        setJobs(normalized);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadSavedJobs();
  }, []);

  return { jobs, loading, error, setJobs };
};

export default useSavedJobs;
